<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup Area
 * @created at      :   2024/05/22
 * @created by      :   ANS902 – quanlh@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import store from '@/store';
import template from './template.html';
import { mapState, mapMutations, mapActions } from 'vuex';
import PopupArea from '@/views/popupSearch/popup_area/store';
/**
 * Define component for popup Fab040120i
 */
import helpers from '@/utils/helpers';

var Area = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupArea')) {
            store.registerModule('PopupArea', PopupArea);
        }
    },
    created() {
        this.onInitScreen();
        this.onSearchItem();
    },
    data() {
        return {};
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    computed: {
        ...mapState('PopupArea', ['listData', 'data', 'totalRows', 'msgNoData'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PopupArea', ['searchAreaInfo']),
        ...mapMutations('PopupArea', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.searchAreaInfo(this.data);
        },
        changeCurrentPage(data) {
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchAreaInfo(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        chooseItem(data) {
            this.$emit('onReferModelValue', data.department_cd);
            this.$emit('onReferValueName', data.department_name);
            this.$emit('close');
        }
    }
};
export default Area;
</script>

<style lang="scss">
@import '@/assets/scss/common/popup.scss';
</style>
